/**
 * Created by fers on 24/08/2017.
 */
import {AlertList, AlertContainer} from "react-bs-notifier";
import {FormattedMessage, defineMessages, IntlProvider} from 'react-intl';
import ReactDOM from 'react-dom';
import React from 'react';
import Relay from 'react-relay';
import {sendError} from './errorDisplayer';
import urlMapping from '../app/URLMapping';
import types from '../../common/model-api/types';
import JobProgress from '../jobs/JobProgress.react';
import GitPullK8sProgress from '../admin/GitPullK8sProgress.react';
import meQuery from '../queries/MeQuery';

import './notification.scss';
import '../layout.scss';

// have only one instance of error dialog
let notificationInstance = null;

class Notification extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            alerts: []
        };

        notificationInstance = this; // eslint-disable-line consistent-this

    }

    componentWillUnmount() {
        notificationInstance = null;
    }

    onAlertDismissed(alert) {
        const alerts = this.state.alerts;

        // find the index of the alert that was dismissed
        const idx = alerts.indexOf(alert);

        if (idx >= 0) {
            this.setState({
                // remove the alert from the array
                alerts: [...alerts.slice(0, idx), ...alerts.slice(idx + 1)]
            });
        }
    }

    clearAlerts() {
        this.setState({
            alerts: []
        });
    }

    addAlert(newAlert) {
        this.setState({
            alerts: [...this.state.alerts, newAlert]
        });
    }

    render() {
        /* we are using require instead of classic 'import' - this code must be able to run on server-side and import locales.po is not supported */
        let locales = require('../locales');
		let getMessagesDefault = require('../getMessages');
        let {getLocale} = locales;
		let {getMessages} = getMessagesDefault;

        return (
            <IntlProvider locale={getLocale()} messages={getMessages()}>
                <AlertContainer position="top-right">
                    <AlertList
                        alerts={this.state.alerts}
                        onDismiss={this.onAlertDismissed.bind(this)}
                    />
                </AlertContainer>
            </IntlProvider>
        );
    }
}

const messages = defineMessages({
    backgroundJobTitle: {id: 'channel.jobTitle', 'defaultMessage': 'Background job started.'},
    backgroundFlowTitle: {id: 'channel.flowInvocationTitle', 'defaultMessage': 'Background flow invoked.'},
});

function sanitizeId(value) {
    if (value === undefined || value === null) {
        return null;
    }

    const trimmed = String(value).trim();
    if (!trimmed || trimmed === 'undefined' || trimmed === 'null') {
        return null;
    }

    return trimmed;
}

export function showJobNotification(intl, job, text : string, infoNote : string = null) {
    const jobRefId = sanitizeId(job && (job.realId || job.id));
    const organisationId = sanitizeId(job && (job.organisation_id || job.organisationId));

    if (!jobRefId) {
        return showNotification(text || intl.formatMessage(messages.backgroundJobTitle),
            <div className="jobProgress">
                {infoNote ? <div><small>{infoNote}</small></div> : null}
                <div><small><FormattedMessage defaultMessage="Job detail is not available yet." id="job.detailNotAvailable" /></small></div>
            </div>);
    }

    let url;

    if (organisationId) {
        url = urlMapping.getUrl(types['jobs'], 'view', {organisation_id: organisationId, id: jobRefId});
    } else {
        url = urlMapping.getUrl(types['jobs'], 'user-view', {id: jobRefId});
    }

	const queryConfig = {
		queries: meQuery,
		name: 'User',
		params: {
            jobId: jobRefId
		}
	};

    showNotification(text || intl.formatMessage(messages.backgroundJobTitle),
        <div className="jobProgress">
			<div className="layout-row">
				<div className="flex-none"><FormattedMessage defaultMessage="Progress:" id="job.progressTitle" />&nbsp;</div>
				<div className="flex progressWrapper">
					<Relay.Renderer
						Container={JobProgress}
						environment={Relay.Store}
						queryConfig={queryConfig}
					/>
				</div>
			</div>
            {infoNote ? <div><small>{infoNote}</small></div> : null}
            <a className="alert-link" href={url} target="_blank"> <FormattedMessage defaultMessage="View details" id="channel.viewDetails" /></a>
        </div>);
}

export function showFlowInvocationNotification(intl, flowInvocation, text : string) {
    let url = urlMapping.getUrl(types['flowInvocations'], 'view', flowInvocation);
    showNotification(text || intl.formatMessage(messages.backgroundJobTitle),
        <span>
            <a className="alert-link" href={url} target="_blank"> <FormattedMessage defaultMessage="See progress." id="channel.watchFlow`Progress" /></a>
        </span>);
}

export function showGitPullK8sNotification(intl, payload) {
    let trackedJobRealId = sanitizeId(payload && payload.trackedJobRealId ? payload.trackedJobRealId : null);
    let trackedJobOrganisationId = sanitizeId(payload && payload.trackedJobOrganisationId ? payload.trackedJobOrganisationId : null);

    if (!trackedJobRealId && payload && payload.message) {
        const trackedMatch = /\[trackedJob:([^:\]]+):([^\]]*)\]/.exec(payload.message);
        if (trackedMatch) {
            trackedJobRealId = sanitizeId(trackedMatch[1]);
            trackedJobOrganisationId = sanitizeId(trackedMatch[2]);
        }
    }

    if (trackedJobRealId) {
        return showJobNotification(
            intl,
            {
                realId: trackedJobRealId,
                organisation_id: trackedJobOrganisationId,
            },
            null,
            'Běží jako samostatný job v k8s.'
        );
    }

    const jobName = payload && payload.jobName ? payload.jobName : null;
    const jobStatus = payload && payload.jobStatus ? payload.jobStatus : 'pending';
    const progressPercent = payload && typeof payload.progressPercent === 'number' ? payload.progressPercent : 5;
    const completed = !!(payload && payload.completed);

    showNotification(
        'Úspěšně spuštěn Git pull',
        <GitPullK8sProgress
            completed={completed}
            jobName={jobName}
            jobStatus={jobStatus}
            progressPercent={progressPercent}
        />
    );
}

export default function showNotification(title, content) {
    try {
        if (!notificationInstance) {
            let notificationDiv = document.createElement('div');
            notificationDiv.style = "z-index: 2000; position: fixed; top: 1em; right: 2em left: 2em;";
            document.body.appendChild(notificationDiv);

            ReactDOM.render(
                <Notification></Notification>,
                notificationDiv
            );
        }

        return notificationInstance.addAlert({
            id: (new Date()).getTime(),
            type: 'success',
            headline: title,
            message: content
        });
    } catch (e) {
        sendError(e);
    }

}
